import { Button } from "dash-ui";
import { useState } from "react";
import { localStorage } from "dash-ui";

// Downloads all properties info in XML format
export const DownloadXmlButton = () => {
  const [isLoading, setIsloading] = useState(false);

  const downloadXML = async () => {
    try {
      setIsloading(true);

      const res = await fetch(
        `${process.env["REACT_APP_REST"]}/properties-xml`,
        {
          headers: {
            accessToken: localStorage.getAccessToken() || "",
            "Content-Type": "application/json",
          },
        }
      );
      const data = await res.json();

      if (!data || !data.content) {
        throw new Error("Failed to download XML.");
      }

      // Get the XML content from the response
      const xmlText = data.content;

      // Create a blob with the XML data
      const blob = new Blob([xmlText], { type: "text/xml" });

      // Create a temporary URL for the blob
      const url = URL.createObjectURL(blob);

      // Create an anchor element and simulate a click for download
      const a = document.createElement("a");
      a.href = url;
      a.download = data.filename || "properties.xml";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      // Revoke the object URL after the download
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading XML file:", error);
    } finally {
      setIsloading(false);
    }
  };

  return (
    <Button onClick={downloadXML} isLoading={isLoading}>
      Download All Properties XML
    </Button>
  );
};
